import React from "react";
import ReactPaginate from "react-paginate";
import { useWindowDimensions } from "@lib-shared/hooks";

type PagerProps = {
    isLoading: boolean;
    currentItems: Array<any>;
    pageCount: number;
    handlePageClick: PageSelectHandler;
    currentPage: number
}

export type PageSelectProps = {
    selected: number
}

export interface PageSelectHandler {
    (selected: PageSelectProps): void
}

const Pager = (props: PagerProps) => {
    const { isLoading, currentItems, pageCount, handlePageClick, currentPage } = props;
    const dimensions = useWindowDimensions();

    if (isLoading || currentItems.length === 0 || pageCount === 1) {
        return null;
    }

    const pageRange = dimensions.width > 500 ? 5 : 3;

    return (
        <section className="pager">
            <ReactPaginate
                breakLabel="..."
                nextLabel=""
                nextClassName="pager-next"
                containerClassName="pager"
                onPageChange={handlePageClick}
                pageRangeDisplayed={pageRange}
                pageCount={pageCount}
                previousLabel=""
                previousClassName="pager-previous"
                //renderOnZeroPageCount={null}
                marginPagesDisplayed={3}
                forcePage={currentPage}
            />
        </section>
    );
}

export default Pager;
